export enum PageBackgroundGradient {
  Home = "linear-gradient(0deg, var(--main-color-10) 0%, var(--main-color-10) 100%), var(--mask-color)",
  Orgs = "radial-gradient(112.94% 78.57% at 0% 100%, #FFF 0%, rgba(255, 255, 255, 0.00) 100%), radial-gradient(117.48% 127.86% at 42.33% -23.28%, rgba(255, 255, 255, 0.70) 6.25%, rgba(193, 209, 255, 0.85) 55.19%, rgba(227, 161, 242, 0.45) 79.26%, rgba(255, 120, 230, 0.10) 100%), linear-gradient(0deg, #FFF 0%, #FFF 100%), #FFF"
}
